import { Routes } from '@angular/router';

import { ConfirmationComponent } from '@features/termination/components/confirmation/confirmation.component';
import { ErrorComponent } from '@features/termination/components/error/error.component';
import { OnboardingComponent } from '@features/termination/components/onboarding/onboarding.component';
import { PersonalInformationComponent } from '@features/termination/components/personal-information/personal-information.component';
import { SummaryComponent } from '@features/termination/components/summary/summary.component';
import { TerminationInformationComponent } from '@features/termination/components/termination-information/termination-information.component';
import { RoutesPath } from '@features/termination/enums';
import { canActivate } from '@features/termination/guards';
import { productListResolver } from '@features/termination/resolvers';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/termination/termination.component').then((m) => m.TerminationComponent),
    resolve: { resolver: productListResolver },
    children: [
      {
        path: RoutesPath.ONBOARDING_PAGE,
        component: OnboardingComponent,
        pathMatch: 'full',
      },
      {
        path: RoutesPath.SUMMARY_PAGE,
        canActivate: [canActivate],

        component: SummaryComponent,
        pathMatch: 'full',
      },
      {
        path: RoutesPath.PERSONAL_PAGE,
        component: PersonalInformationComponent,
        pathMatch: 'full',
      },
      {
        path: RoutesPath.ERROR_PAGE,
        component: ErrorComponent,
        pathMatch: 'full',
      },
      {
        path: RoutesPath.CONFIRMATION_PAGE,
        component: ConfirmationComponent,
        pathMatch: 'full',
      },
      {
        path: RoutesPath.TERMINATION_PAGE,
        component: TerminationInformationComponent,
        pathMatch: 'full',
      },
      { path: '', redirectTo: RoutesPath.ONBOARDING_PAGE, pathMatch: 'full' },
    ],
  },
];
